<template>
  <header class="v1-lmd-header">
    <div class="container-fluid">
      <div class="custom-row">
        <div class="site-logo">
          <router-link id="siteLogo" :to="'/employee/dashboard'">
            <img src="@/assets/lems-v1/images/logo.png" />
          </router-link>
        </div>
        <div class="v1-lmd-hdr-right">
          <div class="header-login">
            <router-link
              class="v1-button-outline"
              id="loginLink"
              :to="'/employee/login'"
            >
              {{ constants.LOGIN_BUTTON }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Employee.json";

export default defineComponent({
  name: "LoginHeader",
  data() {
    return {
      constants,
    };
  },
});
</script>
